import { Dialog, DialogBackdrop, DialogTitle, DialogPanel } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline'

export const Flow = ({ isOpen, onClose, children }) => {

  return <Dialog open={isOpen} onClose={onClose} className="relative z-40">
    <div className="fixed inset-0 overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        <div className={`pointer-events-none fixed inset-y-0 right-0 flex w-screen`}>
          <DialogPanel
            className={`pointer-events-auto w-full `}
          >
            <div className="h-full w-full flex flex-col items-center bg-white shadow-xl overflow-y-auto">
              {children}
            </div>
          </DialogPanel>
        </div>
      </div>
    </div>
  </Dialog>;
}


export const FlowHeader = ({onClose, children}) => <div className="flex w-full bg-white items-center py-5 px-2 border-b border-zinc-100 sticky top-0 z-40">
  <button
    type="button"
    onClick={onClose}
    className="rounded-md z-30 bg-white text-zinc-400 hover:text-zinc-500"
  >
    <span className="sr-only">Close panel</span>
    <XMarkIcon aria-hidden="true" className="size-6" />
  </button>
  {children}
</div>

export const FlowTitle = ({  children }) => <h3 className="ml-2 text-base font-semibold">{children}</h3>;

export const FlowActions = ({ children }) => <div className="ml-auto flex gap-2">{children}</div>;

export const FlowBody = ({ children }) => <div className="grow w-full">{children}</div>;

export const NarrowFlowBody = ({ children }) => <div className="flex flex-col h-full  w-full sm:w-[500px] px-3 sm:px-0 mx-auto">{children}</div>;